import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useContext, useState } from 'react'
import { DiagramViewPortContext } from '../DiagramViewPortContext'
import { forceDownload } from '../../../utils/download'
import { useParams } from 'react-router-dom'
import { useGetMoneyFlow } from '../../../api/case/document'
import { addBranding } from '../../../utils/addBranding'
import { useDarkMode } from '../../../hooks/useDarkMode'

export const ExportDropdown = () => {
    const { container, initialViewPort } = useContext(DiagramViewPortContext)
    const [loading, setLoading] = useState<boolean>(false)
    const { documentId, originalId } = useParams()
    const { data: moneyflow } = useGetMoneyFlow(documentId, originalId)
    const { darkModeEnabled } = useDarkMode()

    if (!container || !moneyflow) {
        return null
    }

    const resolutionScale = 3
    const containerHeight = initialViewPort.height * resolutionScale
    const containerWidth = initialViewPort.width * resolutionScale

    const createName = (format: string) => moneyflow.name + '.' + format

    const exportPng = async () => {
        try {
            setLoading(true)
            const xml = new XMLSerializer().serializeToString(container)
            const data = `data:image/svg+xml;base64,${btoa(xml)}`

            const img = new Image()
            await new Promise((resolve) => {
                img.onload = resolve
                img.setAttribute('src', data)
                img.height = containerHeight
                img.width = (container.width.baseVal.value * containerHeight) / container.height.baseVal.value
            })

            const canvas = document.createElement('canvas')
            const context = canvas.getContext('2d')
            if (!context) {
                throw new Error('Failed to get canvas context')
            }

            canvas.height = containerHeight
            canvas.width = containerWidth

            context.fillStyle = darkModeEnabled ? '#1f1f1f' : 'white'
            context.fillRect(0, 0, canvas.width, canvas.height)

            context.drawImage(img, canvas.width / 2 - img.width / 2, 0, img.width, img.height)

            await addBranding(context, canvas)

            await forceDownload(canvas.toDataURL('image/png'), createName('png'))
        } catch (error) {
            console.error('Error exporting PNG:', error)
        } finally {
            setLoading(false)
        }
    }

    return <Button type='primary' icon={<DownloadOutlined />} onClick={exportPng} loading={loading}></Button>
}
